import Icon from 'veui/components/Icon'
import { IconUndo } from 'dls-icons-vue'

Icon.register('undo', IconUndo)
